export default __webpack_public_path__ + "static/media/17_photo.d01532a2.jpg";